import { generatePath } from "react-router-dom";
import routing from "routing";

export function redirectToAuth() {
	location.href = generatePath(routing.paths.signIn);
}

// TanStack Query 5 nie ma onError/onSuccess w useQuery. Przekierowanie przy 401 robi globalny
// QueryCache.onError (src/index.jsx) — tylko dla zapytań z tym meta, czyli tych, które biorą te opcje.
const defaultConfig = {
	staleTime: 3 * 60 * 1000,
	retry: false,
	refetchOnWindowFocus: false,
	meta: { redirectOn401: true },
};

export default defaultConfig;
